import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import NotificationSnackbar from "../../../../common/notificationBar/notification-snackbar";
import { handleExportToPDF } from "./exportToPDF";

const SelectedTaskExportManager = ({
  kitchenTasks = [],
  activityTasks = [],
  auditTasks = [],
  bedroomTasks = [],
  firstAidTasks = [],
  freezerTasks = [],
  keysTasks = [],
  moneyTasks = [],
  productTasks = [],
  showerTasks = [],
  vehicleTasks = [],
  waterTasks = [],
  taskName,
}) => {
  const [openExportSnackbar, setExportOpenSnackbar] = useState(false);

  const exportTasks = () => {
    handleExportToPDF(
      kitchenTasks,
      activityTasks,
      auditTasks,
      bedroomTasks,
      firstAidTasks,
      freezerTasks,
      keysTasks,
      moneyTasks,
      productTasks,
      showerTasks,
      vehicleTasks,
      waterTasks,
      taskName
    );
    setExportOpenSnackbar(true);
  };

  return (
    <Box>
      <Typography variant='subtitle1' sx={{ fontSize: "18px", fontWeight: "bold" }} align='left'>
        {taskName} Task Report
      </Typography>

      <Typography variant='body2' sx={{ fontSize: "14px", mb: 3 }} align='left'>
        Click the export button to download the filtered {taskName} task details.
      </Typography>

      <Button variant='contained' color='primary' onClick={exportTasks} sx={{ width: "100%", textTransform: "none" }}>
        Export
      </Button>

      <NotificationSnackbar
        open={openExportSnackbar}
        onClose={() => setExportOpenSnackbar(false)}
        color='success'
        message={`${taskName} Task Exported Successfully.`}
      />
    </Box>
  );
};

export default SelectedTaskExportManager;
